export const environment = {
  production: false,
  //baseUrl: 'https://z4yfvr70kf.execute-api.us-east-2.amazonaws.com',
  baseUrl: 'https://test-api.aurorahealth.us',
  stepsUrl: 'https://9zoak5e4nc.execute-api.us-east-2.amazonaws.com/test',
  cognitoUrl: 'https://medsdirectrx.auth.us-east-2.amazoncognito.com',
  redirectUri: 'https://dbs9adv3ir9zi.cloudfront.net',
  clientId: 'bsn5i5cht9v602npje62bi7vu',
  version: '1.0.0'
};
